import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import axios from "axios";
import VueAxios from "vue-axios";
import VueAnalytics from "vue-analytics";
import "./registerServiceWorker";

/* css */
import "./assets/libraries/ui-kit/now-ui-kit.min.css";
import "./assets/libraries/bootstrap/css/bootstrap.min.css";
import "./assets/libraries/ionicons/css/ionicons.min.css";
import "./assets/libraries/contentbuilder/content.css";
import "./assets/libraries/ui-kit/demo.css";
import "./assets/css/iv2-customize.css";
import "./assets/css/iv2-page-animation.css";
import "./assets/css/iv2-theme-c-component.css";

axios.defaults.baseURL = process.env.VUE_APP_API_URL;

// if ("serviceWorker" in navigator) {
//     navigator.serviceWorker
//         .register("/service-worker.js")
//         .then(function(reg) {
//             console.log("登録に成功しました。 Scope は " + reg.scope);
//         })
//         .catch(function(error) {
//             console.log("登録に失敗しました。" + error);
//         });
// }

Vue.config.productionTip = false;

Vue.use(VueAxios, axios);

Vue.use(VueAnalytics, {
    id: axios.get("/json/settings.json").then((response) => {
        return response.data.settings.general.ga_tracking_id;
    }),
});

new Vue({
    router,
    render: (h) => h(App),
}).$mount("#app");
(function() {
    var title = "ivalue | タイトル";
    var keywords = "ivalueキーワード";
    var description = "ivalueディスクリプション";
    document.title = title;
    document
        .querySelector("meta[name='keywords']")
        .setAttribute("content", keywords);
    document
        .querySelector("meta[name='description']")
        .setAttribute("content", description);
    document
        .querySelector("meta[property='og:title']")
        .setAttribute("content", title);
    document
        .querySelector("meta[property='og:description']")
        .setAttribute("content", description);
})();
